var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g({class:['p-inputtextarea p-inputtext p-component', {'p-filled': _vm.filled, 'p-inputtextarea-resizable ': _vm.autoResize}],domProps:{"value":_vm.value}},_vm.listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9ad187a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/textarea/Textarea.vue
// module id = eHyz
// module chunks = 38